import { i18n } from "../../i18n/i18n";

import React, { Component } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import adminRoutes from '../../routes/adminRoutes'
import siteService from '../../services/site.service'
import siteApi, { SiteData } from '../../apis/site.api'
import { ActionName } from '../../components/Actions'
import Button from '../../components/Button'
import ContentLayout from '../../components/ContentLayout'
import ContentMain from '../../components/ContentMain'
import HeadingRow from '../../components/HeadingRow'
import TableHorizontal, {
  TableHorizontalData,
  TableHorizontalHeader
} from '../../components/TableHorizontal'
import Card from '../../components/Card'

interface Props extends RouteComponentProps {}

interface State {
  sites: TableHorizontalData<SiteData>[]
}

class Sites extends Component<Props, State> {
  tableHeaders: TableHorizontalHeader[] = [
    { heading: i18n("Name"), path: 'name' },
    { heading: i18n("Subscriber"), path: 'subscriber.name' },
    { heading: i18n("Users"), path: 'usersCount' },
    { heading: i18n("Permissions"),
      path: 'permissionNames',
      tooltip: ['permissionNames'],
      truncate: true
    },
    { heading: i18n("End at"), path: 'endAt', date: true },
    { heading: i18n("Updated at"), path: 'updatedAt', date: true },
    { heading: i18n("Actions") }
  ]

  constructor (props: Props) {
    super(props)
    this.state = {
      sites: []
    }
    this.handleCreateClick = this.handleCreateClick.bind(this)
    this.handleActionClick = this.handleActionClick.bind(this)
  }

  handleActionClick (id: number, action: ActionName) {
    if (action === 'edit') {
      const pathname = adminRoutes.siteEdit
      const state = { id }
      this.props.history.push({ pathname, state })
    } else if (action === 'resume') {
      siteApi.block(id, subscriber => {
        if (!subscriber) return
        const sites = siteService.block(this.state.sites, id)
        this.setState({ sites })
      })
    } else if (action === 'start') {
      siteApi.unblock(id, subscriber => {
        if (!subscriber) return
        const sites = siteService.unblock(this.state.sites, id)
        this.setState({ sites })
      })
    }
  }

  handleCreateClick () {
    this.props.history.push(adminRoutes.siteCreate)
  }

  listSites () {
    siteApi.list(sites => {
      if (!sites) return
      const sitesData = siteService.tableHorizontalData(sites)
      this.setState({ sites: sitesData })
    })
  }

  componentDidMount () {
    this.listSites()
  }

  render () {
    return (
      <ContentLayout>
        <ContentMain layout="full">
          <Card>
            <HeadingRow heading={i18n("Sites")}>
              <Button
                text={i18n("Create")}
                onClick={this.handleCreateClick} />
            </HeadingRow>
            <TableHorizontal
              headers={this.tableHeaders}
              data={this.state.sites}
              onActionClick={this.handleActionClick} />
          </Card>
        </ContentMain>
      </ContentLayout>
    )
  }
}

export default withRouter(Sites)
